import { ColumnDef } from "@tanstack/react-table";
import { LineClampedTooltip } from "@volca/ui/components/ui/line-clamped-tooltip";
import type { IcmLineItem } from "@/icm/types";

const BusinessUnitCol = (): ColumnDef<IcmLineItem> => ({
  accessorKey: "business_unit_name",
  header: "Business unit",
  meta: { size: "160px" },
  cell: ({ getValue }) => {
    const value = (getValue() as string | null) ?? "–";
    return (
      <LineClampedTooltip className="wrap-break-word">
        {value}
      </LineClampedTooltip>
    );
  },
});

export default BusinessUnitCol;
